import SetMaxSpeedModal from './set-max-speed-modal.vue'
export default SetMaxSpeedModal
